import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { HelpConfig } from '@config/help-config';
import { BaseResourceService } from '@core/services/outros/base-resource.service';
import { LogModel } from '@core/models/log/log.model';
import { MatriculaRequest } from '@core/models/gestao/matricula-gestao.model';

@Injectable({
  providedIn: 'root',
})
export class LogService extends BaseResourceService<LogModel> {

  constructor(
    protected injector: Injector,
    private helpConfig: HelpConfig
  ) {
    super(`${helpConfig.MANAGEMENT_API}transacao`, injector);
  }

  getIdRequest(params: string): Observable<LogModel> {
    return this._httpClient.get<LogModel>(`${this._url}?IdRequisicao=${params}`);
  }

  updateMatricula(resource: MatriculaRequest): Observable<MatriculaRequest> {
    return this._httpClient.put<MatriculaRequest>(this._url, resource);
  }

}
